<template>
  <div class="mt10em">
    <h2 class="basic-sub-title">{{ title }}</h2>
    <div class="v-centerer">
      <span class="legend">
        {{ `${$t('message.CFG_W_INNER_MARGIN')}${$t('message.TWO_DOTS')}` }}
      </span>
      <InputNumber
        :value="value.padding"
        refresh-after-input
        @input="onInput('padding', $event)"
      />
    </div>
    <div class="mt5em mb10em field-hint">
      {{ $t('message.CFG_W_INNER_MARGIN_HINT') }}
    </div>
    <IntCheckbox
      :value="value.shadow"
      :title="$t('message.CFG_W_BORDER')"
      @input="onInput('shadow', $event)"
    />
    <br>
    <IntCheckbox
      :value="value.borderRadius"
      :title="$t('message.CFG_W_ROUNED_CORNER')"
      @input="onInput('borderRadius', $event)"
    />
    <div class="legend mt10em mb10em">
      {{ $t('message.CFG_PAGE_COLOR') }}
    </div>
    <SColorPicker :value="value.bgColor" @input="onInput('bgColor', $event)" />
  </div>
</template>

<script>
import InputNumber from '@/components/input-number.vue';
import IntCheckbox from '@/components/int-checkbox.vue';
import SColorPicker from '@/components/s-color-picker.vue';
import { SColors } from '@/utils/constants';

export default {

  name: 'ExpandableWidgetDesign',

  components: {
    InputNumber,
    IntCheckbox,
    SColorPicker,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({
        padding: 10,
        shadow: 1,
        borderRadius: 1,
        bgColor: SColors.grayBodyBackground,
      }),
    },
  },

  methods: {
    onInput(key, val) {
      if (key === 'padding') {
        if (val > 10) {
          val = 10;
        } else if (val < 0) {
          val = 0;
        }
      }
      this.$emit('input', Object.assign(this.value, { [key]: val }));
    },
  },
};
</script>

<style lang="scss">
.expandable-widget-design {
  .input-number {
    margin-left: 5px;
    width: 50px;
  }
}
</style>
